import axios from 'axios'

function unwrapResponse(response) {
  const payload = response?.data
  if (payload && typeof payload === 'object' && 'data' in payload && 'code' in payload) {
    if (payload.code !== 200) {
      throw new Error(payload.msg || '加载 API 额度失败')
    }
    return { data: payload.data }
  }
  return response
}

/** 经 Java 后台代理 → Python bymy_ai 额度巡检（与 Agent 反馈同一套路） */
export function getLlmQuotaSnapshot() {
  return axios.get('/api/llm-quota').then(unwrapResponse)
}
